export default {
  au: {
    business: require('acq-gcs-pages/bundles/universal/styles/cardDetails/au_cardDetails.css-modules'),
    corporate: require('acq-gcs-pages/bundles/universal/styles/cardDetails/au_cardDetailsCorporate.css-modules')
  },
  it: {
    business: require('acq-gcs-pages/bundles/universal/styles/cardDetails/common.css-modules'),
    corporate: require('acq-gcs-pages/bundles/universal/styles/cardDetails/common.css-modules')
  },
  de: {
    business: require('acq-gcs-pages/bundles/universal/styles/cardDetails/common.css-modules'),
    corporate: require('acq-gcs-pages/bundles/universal/styles/cardDetails/common.css-modules')
  },
  fr: {
    business: require('acq-gcs-pages/bundles/universal/styles/cardDetails/common.css-modules'),
    corporate: require('acq-gcs-pages/bundles/universal/styles/cardDetails/common.css-modules')
  },
  jp: {
    business: require('acq-gcs-pages/bundles/universal/styles/cardDetails/asian_common.css-modules'),
    corporate: require('acq-gcs-pages/bundles/universal/styles/cardDetails/asian_common.css-modules')
  },
  mx: {
    business: require('acq-gcs-pages/bundles/universal/styles/cardDetails/mx_cardDetails.css-modules'),
    corporate: require('acq-gcs-pages/bundles/universal/styles/cardDetails/mx_cardDetailsCorporate.css-modules')
  }
};
